import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });


//pc

//トップに戻るボタン
$(".pageTop").on('click', function(){
  $('body, html').animate({ scrollTop: 0 }, 500);
     return false;
});


//sp
$(document).on('click', '.tglBtn', function () {
  $(".sp_gnav").stop().slideToggle();

});

$(".sp_gnav li > a").on('click', function () {
  $(".sp_gnav").slideUp();
});


/*$(document).on('click', '.menu-btn', function () {
  $(".sp_nav_cnt").fadeIn();
  $('body').addClass('stopscroll');
    $('html').addClass('stopscroll');
});


$(document).on('click', '.close_btn', function () {
  $(".sp_nav_cnt").fadeOut();
  $('body').removeClass('stopscroll');
    $('html').removeClass('stopscroll');
});

$(".sp_nav_cnt ul li > a").on('click', function () {
  $(".sp_nav_cnt").fadeOut();
  $('body').removeClass('stopscroll');
    $('html').removeClass('stopscroll');
});*/


/*let menuFlg = true;
let contactFlg = true;
$(document).on('click', '.menu-btn', function () {
  let $this = $(this);
  let $tar = $this.parent().next();
  //$this.find('.menu-trigger').stop().toggleClass('active');
  if (menuFlg) {
    gsap.to($tar, {
      autoAlpha: 1,
      duration: 0.3
    });
    //$this.find('.word').text('CLOSE');
    //$this.find('.word').addClass('active');
    $('body').addClass('stopscroll');
    $('html').addClass('stopscroll');
    menuFlg = false;
    if (contactFlg == false) {
      gsap.to('.sp_nav_cnt', {
        autoAlpha: 0,
        duration: 0.3
      });
      contactFlg = true;

    }

  } else {

    gsap.to($tar, {
      autoAlpha: 0,
      duration: 0.3
    });
    //$(this).find('.word').text('MENU');
    //$(this).find('.word').removeClass('active');
    $('body').removeClass('stopscroll');
    $('html').removeClass('stopscroll');
    menuFlg = true;
  }
  return false;
});
$(document).on('click', '.sp_nav_cnt > ul > li > a', function () {
  let $this = $(this);
  let $tar = $this.next();
  if (contactFlg) {
    gsap.to($tar, {
      autoAlpha: 1,
      duration: 0.3
    });
    $('body').addClass('stopscroll');
    $('html').addClass('stopscroll');
    contactFlg = false;

    if (menuFlg == false) {
      gsap.to('.sp_nav_cnt', {
        autoAlpha: 0,
        duration: 0.3
      });
      //$('.menu-btn').find('.word').text('MENU');
      //$('.menu-trigger').stop().toggleClass('active');
      menuFlg = true;
    }

  } else {

    gsap.to($tar, {
      autoAlpha: 0,
      duration: 0.3
    });
    $('body').removeClass('stopscroll');
    $('html').removeClass('stopscroll');
    contactFlg = true;

  }
  return false;
});

$(".sp_nav_cnt ul li > a").on('click', function () {
  let $this = $(this);
  let $tar = $(this).next('.child-menu');
  $this.toggleClass('is_active');
  $tar.stop().slideToggle();
  return false;
});*/




/*$(function(){
  var bnr = $('.top_bnr');
  var hide = $('.hide');
  var pos = 0;
  

  $(window).on('scroll', function(){
    
  var elemTop = 100;
  var scroll = $(window).scrollTop();
    
    if(0 > scroll - pos){
      bnr.fadeIn();
      bnr.removeClass(hide);
    }else if(elemTop > scroll){
      bnr.addClass(hide);
      bnr.fadeOut();
    }
    else{
      bnr.addClass(hide);
      bnr.fadeOut();
    }
    pos = scroll;

  });

  (function(){
    var newEvent = new $.Event("scrollstop"),
    timer;
    function newEventTrigger(){
    if (timer) clearTimeout(timer);
    timer = setTimeout(function(){
    $(window).trigger(newEvent)
    }, 1000);
    }
    $(window).on("scroll", newEventTrigger);
    })();

    $(window).on("scrollstop", function(){
      bnr.fadeOut(1000);
      });

});
*/

$(function(){

  var bnr = $('.bnr');

  $(window).on('scroll', function(){

    
    if($(this).scrollTop() > 950){
      bnr.addClass("fixed");
    }else{
      bnr.removeClass("fixed");
    }

  });

});

/*$(window).on('load scroll resize',() => {
  const nav = $('.rf_navArea_pc'),
        //ナビゲーションの位置を取得
        navPosition = nav.offset().top,
        //現在のスクロール位置を取得
        scrollPos = $(window).scrollTop(),
        scroll = scrollPos + 100;
  
  //ナビゲーションの位置までスクロールしたか判定
  if(scroll >= navPosition){
    const content = $('.content_Wrap section');
    
    //コンテンツごとに繰り返し処理
    content.each(function(i,e){
      //コンテンツの開始位置を取得
      const target = $(this).offset().top,
            //コンテンツの終了位置を取得
            targetPosition = target + $(this).innerHeight(),
            //コンテンツのID属性を取得
            id = $(e).attr('id');
      
      //該当するコンテンツまでスクロールしているか判定　＆＆ 該当するコンテンツを通り過ぎたか判定
      if(scroll >= target && scroll < targetPosition){
        //該当するhref属性にクラスを付与
        nav.find('a[href^="#' + id  + '"]').addClass('is-current');
      }else{
        //該当しないhref属性はクラスを削除
        nav.find('a[href^="#' + id  + '"]').removeClass('is-current');
      }
    });
  }

  /*$(function(){
    $(".rf_pageNav li a").on('click', function () {
      $(".rf_pageNav li a").removeClass("is-current");
      $(this).addClass("is-current");
    });
  });*/

/*});*/




